import { render } from "./Port.vue?vue&type=template&id=645d6b75"
import script from "./Port.vue?vue&type=script&lang=js"
export * from "./Port.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Port.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "645d6b75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('645d6b75', __exports__)) {
    api.reload('645d6b75', __exports__)
  }
  
  module.hot.accept("./Port.vue?vue&type=template&id=645d6b75", () => {
    api.rerender('645d6b75', render)
  })

}


export default __exports__